module.exports = __webpack_public_path__ + "static/media/serviceCall.6a65a1d1.png";